import { useState } from 'react';
import { Icon } from '../ui/icons';
import { AuditTab } from './AuditTab';
import { OrgsTab } from './OrgsTab';
import { UsersTab } from './UsersTab';

export interface AdminPanelProps {
  /** Switches the dashboard to that organisation's boards view. */
  onOpenOrg: (orgId: string) => void;
}

/**
 * Super-admin-only screen: every account and every organisation, independent
 * of what the viewer happens to belong to. Reachable only via the "Админка"
 * nav item, which `OrgSidebar` only renders for `user.isSuperAdmin`.
 */
export function AdminPanel({ onOpenOrg }: AdminPanelProps) {
  const [tab, setTab] = useState<'users' | 'orgs' | 'audit'>('users');

  return (
    <section className="dash-content">
      <header className="dash-header">
        <div>
          <h1>Админ-панель</h1>
          <p className="dash-subtitle">Пользователи и организации на всём сервере</p>
        </div>
      </header>

      <div className="auth-tabs admin-tabs">
        <button type="button" className={tab === 'users' ? 'is-active' : ''} onClick={() => setTab('users')}>
          <Icon name="users" size={14} /> Пользователи
        </button>
        <button type="button" className={tab === 'orgs' ? 'is-active' : ''} onClick={() => setTab('orgs')}>
          <Icon name="org" size={14} /> Организации
        </button>
        <button type="button" className={tab === 'audit' ? 'is-active' : ''} onClick={() => setTab('audit')}>
          <Icon name="shield" size={14} /> Журнал
        </button>
      </div>

      {tab === 'users' && <UsersTab />}
      {tab === 'orgs' && <OrgsTab onOpenOrg={onOpenOrg} />}
      {tab === 'audit' && <AuditTab />}
    </section>
  );
}
